import { useCallback, useState } from 'react';

export const DEFAULT_PAGE_SIZE = 50;
const PAGE_SIZE_SUFFIX = '-page-size';

const parseStoredPageSize = (storedValue: string | null, fallback: number) => {
  const parsed = Number.parseInt(storedValue ?? '', 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

const getStorageKey = (key: string) =>
  key.endsWith(PAGE_SIZE_SUFFIX) ? key : `${key}${PAGE_SIZE_SUFFIX}`;

export const usePersistedPageSize = (storageKey: string, fallback = DEFAULT_PAGE_SIZE) => {
  const key = getStorageKey(storageKey);
  const [pageSize, setPageSizeState] = useState<number>(() => {
    if (typeof window === 'undefined') return fallback;

    try {
      return parseStoredPageSize(window.localStorage.getItem(key), fallback);
    } catch {
      return fallback;
    }
  });

  const setPageSize = useCallback((size: number) => {
    setPageSizeState(size);

    if (typeof window === 'undefined') return;

    try {
      window.localStorage.setItem(key, size.toString());
    } catch {
      // ignore storage failures
    }
  }, [key]);

  return { pageSize, setPageSize };
};

